import { render, staticRenderFns } from "./IconMoonSolid.vue?vue&type=template&id=fef1d318"
import script from "./IconMoonSolid.vue?vue&type=script&lang=js"
export * from "./IconMoonSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports